



















import { Vue, Component } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import TabMenu from '@/components/common/TabMenu.vue';
import { TabType } from '@/types/promotion';
import { tabMenus } from '@/views/promotion/freeGift/FreeGift';
@Component({
  components: { PageTitle, TabMenu },
})
export default class FreeGiftPage extends Vue {
  private readonly tabMenus = tabMenus;
  
  private get currentTab(): TabType {
    return this.$route?.meta?.tab as TabType ?? 'configuration';
  }
}
